import React from "react"
import globalStyles from "../../services/globalStyles.module.scss"
import styles from "./feature.module.scss"

import play from "../../images/common/play.svg"
import PieTimer from "../pieTimer";
import Slider from "./slider2";

class FeatureTMP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      loaded: false,
    }
    this.videoRefs = [];
    this.imageTimer = null;
    this.addRef = this.addRef.bind(this);
    this.videoCanplay = this.videoCanplay.bind(this);
    this.videoEnded = this.videoEnded.bind(this);
    this.getCurrAnimTime = this.getCurrAnimTime.bind(this);
    this.selectVideo = this.selectVideo.bind(this);
  }

  addRef(ref) {
    if (ref != null) {
      this.videoRefs.push(ref);
    }
  }

  selectVideo(index) {
    if (this.imageTimer) clearTimeout(this.imageTimer);
    this.videoRefs.forEach(val => {
      if(val.nodeName != "IMG"){
        val.pause();
        val.currentTime = 0;
      }
    });
    this.setState({ activeIndex: index });
    this.videoRefs[index].nodeName != "IMG" && this.videoRefs[index].play();
  }

  videoCanplay() {
    if (!this.state.loaded) {
      this.setState({ activeIndex: 0, loaded: true });
      if(this.props.isVisible){
        this.videoRefs[0].nodeName != "IMG" && this.videoRefs[0].play();
      }
    }
  }

  videoEnded() {
    if (this.state.activeIndex === this.videoRefs.length - 1) {
      this.videoRefs[0].nodeName != "IMG" && this.videoRefs[0].play();
      this.setState({ activeIndex: 0 });
    } else {
      this.videoRefs.forEach(val => {
        val.nodeName != "IMG" && val.pause();
        if(val.nodeName != "IMG")
        {
          val.currentTime = 0;
        }
      });
      const newIndex = this.state.activeIndex + 1
      this.videoRefs[newIndex].nodeName != "IMG" && this.videoRefs[newIndex].play();
      this.setState({ activeIndex: newIndex });
    }
  }

  componentDidMount() {
    this.videoRefs[0].nodeName != "IMG" && this.videoRefs[0].addEventListener("canplay", this.videoCanplay);

    this.videoRefs.forEach((val) => {
      val.nodeName != "IMG" && val.addEventListener("ended", this.videoEnded);
    });
  }

  componentWillUnmount() {
    this.videoRefs[0].nodeName != "IMG" && this.videoRefs[0].removeEventListener("canplay", this.videoCanplay);

    this.videoRefs.forEach((val) => {
      val.nodeName != "IMG" && val.removeEventListener("ended", this.videoEnded);
    })
  }

  componentWillReceiveProps(newProps){
    if (newProps.videos) {
      this.videoRefs.forEach((v,i) => {
        if (v.nodeName != "IMG" && this.props.videos[i] != newProps.videos[i]) {
          v.load()
        }
      })
    }
    if(newProps.isVisible && !this.props.isVisible){
      this.videoRefs[this.state.activeIndex].nodeName != "IMG" && this.videoRefs[this.state.activeIndex].play();
    } else if(!newProps.isVisible && this.props.isVisible){
      this.videoRefs.forEach(val => {
        val.nodeName != "IMG" && val.pause();
        if(val.nodeName != "IMG"){
          val.currentTime = 0;
        }
      });
    }
  }

  getCurrAnimTime() {
    if(this.videoRefs[this.state.activeIndex].nodeName == "IMG"){
      this.imageTimer = setTimeout(() => {
        this.selectVideo(this.state.activeIndex < this.videoRefs.length - 1 ? this.state.activeIndex + 1 : 0);
      }, this.props.slowAnimation ? 8000 : 5000)
      return this.props.slowAnimation ? "8s" : "5s";
    }
    return this.videoRefs[this.state.activeIndex] && this.videoRefs[this.state.activeIndex].duration + "s";
  }

  render() {
    const { dividerColor, left, videos, isVisible, texts } = this.props;
    const { activeIndex } = this.state;

    return <div>
      <div className={[styles.contentDivider, dividerColor].join(' ')} />
      <div className={[globalStyles.column, styles.column2].join(' ')}>
        <h1 className={styles.contentHeader}>
          {texts.section_header}
        </h1>
        <div className={[globalStyles.rowOnDesktopColumnOnMobile, styles.contentContainer, styles.contentPadding].join(' ')}>
          <div className={left ? styles.contentImageWrap : [styles.contentImageWrap, styles.order].join(' ')}>
            {videos.map((val, index) => {
              return index > texts.length - 1 ? null : (val.video.includes("mp4")) ? <video key={index} ref={this.addRef} style={activeIndex === index ? {} : { display: "none" }} className={styles.contentImage} id="video" muted playsInline>
              <source src={val.video} type='video/mp4' />
            </video> : <img src={val.video} ref={this.addRef} style={activeIndex === index ? {} : { display: "none" }} className={styles.contentImage}/>
            })}
          </div>
          <div className={styles.sliderWrapper}>
            <Slider videos={videos} index={this.state.activeIndex} selectIndex={this.selectVideo} />
          </div>
          <div className={[globalStyles.hideOnDesktop, styles.videoMarkersContainer].join(' ')}>
            {texts.texts.map((_, index) => {
              return <span key={index} className={[styles.videoMarker, activeIndex === index && styles.activeVideoMarker].join(' ')} onClick={() => { this.selectVideo(index) }} />
            })}
          </div>
          <div className={[styles.contentText, left ? styles.contentTextLeft : styles.contentTextRight].join(' ')}>
            <p
              className={
                left
                  ? styles.featureDescriptionLeft
                  : styles.featureDescription
              }
            >
              {texts.section_description}
            </p>
            {texts.texts.map((val, index) => {
              return <div key={index} onClick={() => { this.selectVideo(index) }} className={[styles.justifyContent, styles.featureDetailContainer, activeIndex === index && styles.activeSlide, left ? styles.featureDetailMarginLeft : styles.featureDetailMarginRight].join(' ')}>
                {activeIndex === index && isVisible ? <div className={styles.iconTimer}><PieTimer isVisible={isVisible} animDuration={this.getCurrAnimTime()} /></div> : <img className={styles.icon} src={play} alt="" />}
                <div
                  className={
                    texts.section_description
                      ? [
                          globalStyles.column,
                          styles.featureDetail,
                          styles.withDescription,
                        ].join(" ")
                      : [globalStyles.column, styles.featureDetail].join(
                          " "
                        )
                  }
                >
                  <h4>{val.header}</h4>
                  <p>{val.paragraph}</p>
                  <div className={[styles.paragraphDivider, globalStyles.hideOnMobile].join(' ')} />
                </div>
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
  }
}

FeatureTMP.propTypes = {

}


export default FeatureTMP
